import { DataBean } from "../DataBean";

export class LoanDestination extends DataBean{


    public async getLoanDestinationCatalog(id:any):Promise<any>
    {
        return this.getCustomService("QuickDataERPCore","java.util.List_getLoanDestinationCatalog_Number",[id]);
    }
}